import { arrayRemove, doc, updateDoc } from 'firebase/firestore';
import { db } from '../firebaseConfig';

export async function onDeclineFriendRequest(id, userID) {
  const userRef = doc(db, 'users', userID);

  await updateDoc(userRef, {
    friendRequests: arrayRemove(id)
  });
}